<template>
  <div>
    <h2 class="margin-top-off size-18 upper weight-normal color-gray-light-mid">
      <span class="upper">{{ direction }}</span>&nbsp;<strong class="color-gray-dark weight-normal">{{ segments[0].date_departure | dateToMonthday }}</strong>
    </h2>
    <div class="row">
      <p class="col-xs-3 text-left min-line-height">
        <span class="size-18">{{ segments[0].date_departure | dateToHour }}</span><br>
        <span class="size-16 weight-mid color-gray-light-mid">{{ segments[0].origin.iata_code }}</span><br>
        <span class="size-12 weight-normal">{{ segments[0].origin.city_name }}</span><br>
      </p>
      <div class="col-xs-6 text-center _pr-0 _pl-0">
        <div class="hour-mark">
          <i class="fa fa-plane fa-fw ico-plane"></i>
        </div>
        <p class="size-14">
          <!-- <span class="weight-lighter">{{ 'voos' | pluralize(segments.length) }}:</span> -->
          <span
            v-for="(segment, index) in segments"
            :key="`flight-hourly-fligh-number-${index}`">
            {{ segment.carrier.iata_code }} {{ segment.flight_number | normalizeFlightNumber }}
          </span>
        </p>
      </div>
      <p class="col-xs-3 text-right min-line-height">
        <span class="size-18">{{ segments[segments.length - 1].date_arrival | dateToHour }}<sup v-if="dateDiffArrival > 0" class="color-magenta">+{{ dateDiffArrival }}</sup></span><br>
        <span class="size-16 weight-mid color-gray-light-mid">{{ segments[segments.length - 1].destination.iata_code }}</span><br>
        <span class="size-12 weight-normal">{{ segments[segments.length - 1].destination.city_name }}</span><br>
      </p>
    </div>

    <div class="row">
      <p class="col-xs-12 text-left">
          <span
              v-for="(carrier, index) in getCarriers()"
              :key="`carrier-iatacode-${index}`">
          <a
              ref="farerulesLink"
              target="_blank"
              :href="farerulesLink[carrier.iata_code]"
              class="btn-link size-14 weight-normal">
                  ver regras tarifárias da {{carrier.name.split(' ')[0]}}
                </a>
            </span>
      </p>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import farerulesLink from "@/data/farerulesLink";

export default {
  data() {
    return {
      farerulesLink
    }
  },
  props: [
    'segments',
    'direction'
  ],
  computed: {
    dateDiffArrival () {
      return moment(this.segments[this.segments.length - 1].date_arrival, 'YYYY, MM, DD').diff(moment(this.segments[0].date_departure, 'YYYY, MM, DD'), 'days')
    },
  },
  methods: {
    getCarriers() {
      let carriers = []
      this.segments.map(segment => carriers.push(segment.carrier))
      carriers = carriers.filter(function (a) {
        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
      }, Object.create(null))
      return carriers
    }
  }
};
</script>
